import { Modal } from 'react-bootstrap';
import { BookingRequestRead } from '../../../api';
import { BookingRequestStatusBadge } from '../BookingRequestStatusBadge';

interface DialogHeaderProps {
  bookingRequest: BookingRequestRead;
}

export const DialogHeader = ({ bookingRequest }: DialogHeaderProps) => (
  <Modal.Header closeButton className="bg-neutral-200">
    <h4 className="pt-1">
      Review Assignment Request
      <BookingRequestStatusBadge
        status={bookingRequest.status}
        bookings={bookingRequest.bookings}
        className="ms-2"
      />
    </h4>
  </Modal.Header>
);
